export const APPOINTMENT_SECTOR = {
    FIND: 'FIND_APPOINTMENT_SECTORS',
    GET: 'GET_APPOINTMENT_SECTORS',
    GET_ALL: 'GET_ALL_APPOINTMENT_SECTORS',
    CHANGE_STATUS: 'CHANGE_STATUS_APPOINTMENT_SECTORS',
    SUCCESS: 'SUCCESS_APPOINTMENT_SECTORS',
    ERROR: 'ERROR_APPOINTMENT_SECTORS',
    CLEAN: 'CLEAN_APPOINTMENT_SECTORS',
}